// @ts-nocheck
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { PagesCollectionModel } from "@insite/client-framework/Services/ContentService";
import { getEvents } from "@store/Framework/Services/EventsService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

export interface GetEventsApiParameter extends ApiParameter {
    startDate?: string;
    endDate?: string;
    category?: string;
    province?: string;
    pageSize?: number;
    isFeatured?: boolean;
}

type HandlerType = ApiHandler<
    GetEventsApiParameter & HasOnSuccess<PagesCollectionModel> & HasOnError,
    PagesCollectionModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
    props.apiResult = await getEvents(props.apiParameter);
    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: props.apiResult,
        links: state.links,
        ...getContextData(state),
    });
};

export const CallOnSuccess: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const CallOnError: HandlerType = props => {
    if (!props.apiResult) {
        props.parameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, CallOnSuccess, CallOnError];

const getEventList = createHandlerChainRunner(chain, "GetEventList");
export default getEventList;
